<div class="row gap-8 space-between align-center">
  <div class="col gap-4">
    <h2 i18n>Feedback Board</h2>
    <div>{{ data?.name }}</div>
  </div>
  <div class="row gap-16 align-center">
    <rr-btn
      iconStart="miro"
      size="Small"
      type="Secondary"
      (click)="miroExport()"
      >Export</rr-btn
    >
    <rr-btn
      iconStart="pdf"
      size="Small"
      type="Secondary"
      [disabled]="!bmcReady"
      (click)="bmcReady ? generateBmc() : null"
      >Generate BMC</rr-btn
    >
    <rr-icon
      name="close"
      class="pointer"
      color="nutral"
      (click)="close()"
    ></rr-icon>
  </div>
</div>
<div class="agentwrapper w100 col grow-1">
  <div class="row gap-16 align-start justify-start w100 grow-1">
    <div class="col agentcol gap-16" *ngFor="let agent of pins">
      <div class="row space-between w100">
        <div class="col gap-4">
          <h3 class="strong">{{ agent.agentName }}</h3>
          <rr-btn
            type="Link"
            class="underline"
            (click)="gotoAgent(agent.agentId)"
            >Chat with Expert</rr-btn
          >
        </div>
        <rr-btn
          type="Secondary"
          size="Small"
          iconStart="file"
          *ngIf="agent.pins?.length > 0"
          [disabled]="agent.reportId === '' ? true : false"
          class="btn-with-padding"
          (click)="
            agent.reportId && agent.reportId !== ''
              ? generateReport(agent.reportId)
              : null
          "
          >Report</rr-btn
        >
      </div>
      <div class="w100 col gap-8">
        <rr-pin
          [pin]="pin"
          *ngFor="let pin of agent.pins"
          (priorize)="priorizePin(pin)"
          (edit)="editPin(pin)"
          (delete)="deletePin(pin)"
        ></rr-pin>
      </div>
    </div>
  </div>
</div>
<rr-spinner *ngIf="loading"></rr-spinner>
